export default class Thunder {
    constructor(adapter) {
        this.client = adapter.getPlatformClient()
    }

    async read(type, filters, flag, options) {
        const { data } = await this.client.post("/v3/system/thunder", {
            type,
            filters,
            flag,
            options, 
        })

        return data
    }

    async write(type, filters, d, flag) {
        const { data } = await this.client.put("/v3/system/thunder", {
            type,
            filters,
            flag,
            data: d, 
        })

        return data
    }

    async operation(name, filters, data) {
        return await this.write(name, filters, data, "Operation")
    }

    async find(name, filters) {
        return await this.read(name, filters, "Find")
    }

    async findOne(name, filters) {
        return await this.read(name, filters, "FindOne")
    }

    async paginate(name, filters, options) {
        return await this.read(name, filters, "Paginate", options)
    }

    async upsert(name, filters, data) {
        return await this.write(name, filters, data, "Upsert")
    }

    async insertOne(name, data) {
        return await this.write(name, {}, data, "InsertOne")
    }

    async updateOne(name, filters, data) {
        return await this.write(name, filters, data, "UpdateOne")
    }

    async delete(name, filters) {
        return await this.write(name, filters, {}, "Delete")
    }
}